import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../components/Forms/PresetsTextField'

const MajorIncidentPlan = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <PresetsTextField
        label="Major Incident Plan"
        multiline
        minRows={2}
        value={medPlan?.majorIncidentPlan}
        fullWidth
        suggestionPath="medPlan.majorIncidentPlan"
        suggestionLabel="Major incident plans from templates"
        setValue={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            majorIncidentPlan: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.majorIncidentPlan,
        }}
      />
    </Grid>
  )
}

export default React.memo(MajorIncidentPlan)
